/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../lib/@waca/core-client/js/core-client/ui/core/Events'], function(Events) {
	var EventRouter = Events.extend({});
	return EventRouter;
});
